import { CartKeys } from '~/composables/useCart'

export const useCartWithSubdomainLogic = (): ReturnType<typeof useCart> => {
  const subdomain = useSubdomain()

  return useCart(subdomain.value || CartKeys.GENERAL)
}
